var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"jobApplicationFilter"}},[_c('SelectedStatisticsFilters'),_c('transition',{attrs:{"name":"filters-fade"}},[(_vm.isStatisticsFiltersPanelDisplayed)?_c('AdvancedStatisticsFilters'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }